import { render, staticRenderFns } from "./CusPaymentsTableOtherMobile.vue?vue&type=template&id=3b45c7ac&scoped=true"
import script from "./CusPaymentsTableOtherMobile.vue?vue&type=script&lang=js"
export * from "./CusPaymentsTableOtherMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b45c7ac",
  null
  
)

export default component.exports